<template>
    <div class="courseChoose"
        :style="{ 'width': _isMobile() ? '100%' : '1200px', 'margin': _isMobile() ? '-28px auto' : 'auto' }">
        <div class="mainContent" :style="{ borderRadius: _isMobile() ? '28px 28px 0 0' : 'none' }"
            v-if="dataSource.length > 0">
            <div class="header">
                <template v-if="_isMobile()">
                    <i class="iconfont">&#xe664;</i>课程选择
                </template>
            </div>
            <template>
                <a-row type="flex" justify="space-around" :gutter="[0, 20]" style="width: 90%;margin: 0 auto;">
                    <a-col :xs="11" :sm="11" :md="7" :lg="7" :xl="7" v-for="item, index in dataSource" :key="index">
                        <div class="menuList" @click="openHandelFn(item)">
                            <img  :src="require('../../assets/image/KC_BG'+ item.index +'.png')" style="width: 100%;height: 100%;" alt="">
                            <div class="menuName">{{ item.name }} <i class="iconfont"
                                    style="font-size: 20px;">&#xe626;</i></div>
                        </div>
                    </a-col>
                </a-row>
            </template>
        </div>
    </div>
</template>

<script>
import { mixinDevice } from "@/utils/mixin.js";
import { getAction, postAction } from '@/api/manage'
export default {
    name: 'courseChoose',
    components: {},
    mixins: [mixinDevice],
    data() {
        return {
            dataSourceOne: {},
            dataSource: [],
            pageType: ''
        }
    },
    created() {
        this.pageType = this.$route.query.type
        this.init(this.$route.query.type)
    },
    mounted() { document.title = this.$route.query.name },
    methods: {
        init(type) {
            this.loading = true
            getAction('/sys/category/childListByCode?code=A07').then(res => {
                if (res.success) {
                    res.result.forEach((element,index) => {
                        if(index < 5){
                            element.index = index
                        }else{
                            element.index = index-5
                        }
                    });
                    this.dataSource = res.result
                }
            })

        },
        openHandelFn(row) {
            console.log(row)
            if (this.pageType == 'ZXKS'  || this.pageType == 'BJZY') {
                this.$router.push({ path: 'examEntrance', query: { paperType: row.comment, type: this.pageType } });
            } else if (this.pageType == 'ZXXX' || this.pageType == 'ZXLX' ) {
                this.$router.push({ path: '/course/operate', query: { name: row.name,id:row.id, code:row.code,pageType:this.pageType } });
            } else {
                this.$router.push({ path: 'operate', query: { name: row.courseName, id: row.id,pageType:this.pageType } });
            }
        }
    }
}
</script>

<style lang='scss' scoped>
.courseChoose {
    width: 100%;
    margin: -28px auto;

    .mainContent {
        width: 100%;
        background: #fff;

        .header {
            width: 100%;
            height: 70px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 17px;
            color: #333;
            position: relative;

            .jxwLogo {
                width: 67px;
                height: 70px;
                position: absolute;
                top: -31px;
                right: 13px;
                z-index: 9;
            }
        }
    }

    .menuList {
        width: 100%;
        height: 120px;
        background-size: 100% 100%;
        border-radius: 14px;
        box-shadow: 0px 0px 12px 0px rgba(25, 32, 68, 0.35);
        overflow: hidden;
        position: relative;
        cursor: pointer;

        .menuName {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            background: #33333338;
            font-size: 36px;
            color: #fff;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;

            .iconfont {
                padding-left: 8px;
            }
        }
    }
}
</style>